'use strict'

import React, {Component} from 'react';
import {Row} from 'react-flexbox-grid';
import '../styles/App.css';
import Interviewers from '../app/getInterviewers';


class Interview extends Component {

  render() {
    return (
      <div>
        <section className="section">
        <h1 className="homeTitle">Modalidad de participación: Entrevistas</h1>
          <Row className="descriptionRow">
            <div className="newspaper">
              <p className="descriptionParagraph">
              Los empresarios realizarán
               entrevistas con el fin de establecer
               y/o conocer su experiencia y conocimientos como posible
               colaborador o como posible empresario y, por supuesto, como
               persona. Los empresarios desean profundizar en temas laborales y
               empresariales, que les permita conocer más acerca de la
               formación del participante como futuro trabajador o empresario,
               y diferentes aspectos de relevancia que se deben tener en cuenta
               al elegir un colaborador o un socio.
               Los interesados podrán programar su entrevista en aplicación en
               línea según la disponibilidad de cada empresa.
               Cada entrevista tendrá una duración aproximada de 15 minutos.
              </p>
            </div>
          </Row>
          <h1 className="homeTitle tabsTitle">¿Cómo tener una entrevista? </h1>
          <Row className="descriptionRow">
          <p className="descriptionParagraph">
          En esta ocasión contaremos con la presencia de cuatro empresas de software,
          las cuales tienen una amplia experiencia en el campo de la tecnología y el desarrollo.
          </p>

            <Interviewers/>
          </Row>
        </section>
      </div>
    );
  };
}

export default Interview;



// WEBPACK FOOTER //
// ./src/interviews/interviews.js